module.exports = __webpack_public_path__ + "img/undraw_online_friends_x73e.3a43ee0c.svg";